export var EStatus = /*#__PURE__*/function (EStatus) {
  EStatus["Added"] = "added";
  EStatus["Available"] = "available";
  EStatus["Unavailable"] = "unavailable";
  return EStatus;
}({});